import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';

import Input from '@vromo/ui/components/Input';
import Flex from '@vromo/ui/components/Flex';

type CapacityInputProps = {
    load: number;
    editLoad: (newLoad: number) => void;
};

const CapacityInput = observer(function CapacityInput({ load, editLoad }: CapacityInputProps) {
    const [inputVal, setInputVal] = useState(load);

    return (
        <Flex vertical='middle'
            style={{
                flex: 2,
                marginLeft: '10px',
                maxWidth: '70px'
            }}>
            <Input
                style={{
                    height: 'unset',
                    padding: '10px',
                    marginTop: '0px',
                    textAlign: 'center'
                }}
                noTopMargin
                value={inputVal || ''}
                type="number"
                step={'1'}
                min="0"
                onChange={(e: { target: { value: any } }) => setInputVal(e.target.value)}
                onBlur={(_: any) => {
                    const parsedVal = parseFloat(parseFloat(inputVal.toString()).toFixed(1));
                    setInputVal(parsedVal);
                    editLoad(parsedVal);
                }}
            />
        </Flex>
    );
});

export default CapacityInput;
